import React, { Component } from 'react';
import { connect } from 'react-redux';

import { COMMENT_REPLY_CONTAINER_CLASS } from 'constants/comments';
import { deleteReplyCreator } from 'creators/comments';
import { getCloudfrontURI } from 'utilities/avatar';
import {
  getFormattedDateForHeader,
  playVideoAtTimestamp,
  sanitizeContent,
  userCanDelete,
} from 'utilities/comments';

import avatarPlaceholder from 'img/icons/comments-avatar-placeholder.svg';

import './styles.less';

const Reply = class extends Component {
  render() {
    const { currentUserIsOwner, companyFeatureData, reply, user } = this.props;

    const avatar = reply.avatar && reply.avatar.thumb;

    const { brand_primary_color: brandColor } = companyFeatureData || {};
    const textStyle =
      !currentUserIsOwner && brandColor ? { color: brandColor } : null;

    return (
      <div className="reply-container" id={`reply-${reply.id}`}>
        <hr />
        {avatar && (
          <img src={getCloudfrontURI(avatar)} className="reply-avatar" />
        )}
        {!avatar && <img src={avatarPlaceholder} className="reply-avatar" />}
        <div className="comment-reply">
          <div className="reply-header">
            <div className="user-name"> {reply.user_name} </div>
          </div>
          <div
            className={COMMENT_REPLY_CONTAINER_CLASS}
            dangerouslySetInnerHTML={{ __html: sanitizeContent(reply) }}
            onClick={playVideoAtTimestamp}
          />
          <div className="actions-section">
            {userCanDelete(reply, currentUserIsOwner, user) && (
              <span
                className="delete-reply"
                onClick={this.deleteReply}
                style={textStyle}
              >
                Delete
              </span>
            )}
            <span className="reply-date-section">
              {getFormattedDateForHeader(reply.createdAt)}
            </span>
          </div>
        </div>
      </div>
    );
  }

  deleteReply = () => {
    const { reply } = this.props;

    if (window.confirm('Are you sure you want to delete this reply?')) {
      this.props.deleteReply(reply);
    }
  };
};

const mapStateToProps = state => {
  const { share_video, user } = state;
  const { current_user_is_owner: currentUserIsOwner } = share_video;
  const { company_feature_data: companyFeatureData } = share_video.video;

  return { currentUserIsOwner, companyFeatureData, user };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteReply: reply => dispatch(deleteReplyCreator(reply)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reply);
